import { render } from "./MawiCustomers.vue?vue&type=template&id=ebac159a&scoped=true"
import script from "./MawiCustomers.vue?vue&type=script&lang=js"
export * from "./MawiCustomers.vue?vue&type=script&lang=js"

import "./MawiCustomers.vue?vue&type=style&index=0&id=ebac159a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebac159a"]])

export default __exports__